import type { ReminderSettings } from '@/core/domain';
import type { ReminderSettingsRepository } from '../repositories/reminder-settings-repository';

export class CreateReminderSettingsUseCase {
  constructor(private readonly repository: ReminderSettingsRepository) {}

  async execute(userId: string, settings: ReminderSettings): Promise<ReminderSettings> {
    return this.repository.create(userId, settings);
  }
}
